import { Button, Dialog, DialogContent, IconButton, Stack } from "@mui/material"

import { useTranslation } from "react-i18next"
import {
  Close as CloseIcon,
  Edit as EditIcon,
  CheckCircleOutline as CheckCircleOutlineIcon
} from '@mui/icons-material'

import { defaultFunction } from "../../utilities/utilities"

function CheckoutDialog(props) {
  const {
    open = false,
    onEditCheckoutDialog = defaultFunction,
    onExitCheckoutDialog = defaultFunction,
    onClose = defaultFunction,
  } = props

  const { t } = useTranslation()

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={open}
      onClose={onClose}
      aria-labelledby="responsive-dialog-title">
      <DialogContent className="dialog-info-content">
        <Stack gap={2} alignItems="center">
          <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
            <Stack direction="row" alignItems="center" gap={1}>
              <h2>{t('Do you want to edit or mark the visitor as out?')}</h2>
            </Stack>
            <IconButton
              aria-label="close"
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
          <Stack
            spacing={2}
            justifyContent="center"
            direction="row"
            alignItems="center"
            width="100%">
            <Button
              fullWidth
              startIcon={<EditIcon />}
              size="large"
              variant="outlined" 
              onClick={onEditCheckoutDialog}>
              {t('Edit Visit')}
            </Button>
            <Button
              fullWidth
              startIcon={<CheckCircleOutlineIcon />}
              size="large"
              variant="contained"
              color="success"
              onClick={onExitCheckoutDialog} >
              {t('exit confirmation')}
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default CheckoutDialog
